export default "__VITE_ASSET__CXdY0T$n__"